import { TextInput } from '@rbilabs/components-library';
import styled from 'styled-components';

import { ModalHeading } from 'components/modal';

export const StyledModalHeader = styled(ModalHeading)`
  margin: 1rem auto;
  font-size: 1.85rem;
  max-width: 100%;
`;

export const ModalContent = styled.div`
  width: calc(100% - 4.75rem);
  margin: 0 auto;
`;

export const StyledForm = styled.form`
  margin-block-end: 0.5rem;
  width: 100%;
`;

export const NameInput = styled(TextInput)`
  width: 100%;
`;
